export default __webpack_public_path__ + "static/media/project_shot_east_douglas_1.56ae7c51.jpg";